import { Button, cn } from "@tellescope/ui";
import { ReactNode } from "react";
import { useShallowNavbarStore } from "../store";
import { PanelLeft } from "lucide-react";
import { PAGE_HEADER_SIZE_STRING } from "../constants/header-sizing";

export interface PageTabsHeaderProps {
  children: ReactNode;
  className?: string;
}

export const PageTabsHeader = ({ children, className }: PageTabsHeaderProps) => {
  const { isCollapsed, toggleCollapsed } = useShallowNavbarStore("isCollapsed", "toggleCollapsed");

  return (
    <div
      className={cn(
        `flex items-center pl-2 min-h-[${PAGE_HEADER_SIZE_STRING}] h-[${PAGE_HEADER_SIZE_STRING}] w-full border-b border-b-gray-200 flex-shrink-0`,
        className
      )}
    >
      <Button
        variant="ghost"
        size="icon"
        className="w-9 h-9 rounded-md shrink-0"
        onClick={toggleCollapsed}
        title={isCollapsed ? "Expand sidebar" : "Collapse sidebar"}
      >
        <PanelLeft className="h-5 w-5" />
      </Button>
      <div className="h-full w-full [&_[role=tablist]]:border-b-0">{children}</div>
    </div>
  );
};
